import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";

@Component({
  selector: 'micro-db2SmsConfig-select',
  templateUrl: './db2SmsConfig-select.component.html'
})
export class Db2SmsConfigSelectComponent implements OnInit, OnChanges {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  db2SmsConfigIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  db2SmsConfigId:any = '';

  @Input()
  companyId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  change(e) {
    this.db2SmsConfigIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'companyId') {
        this.reload();
      }
    }
  }

  reload() {
    let params:HttpParams = new HttpParams();
    this.sel.loading = true;

    if (this.companyId) {
      params = params.set("companyId", this.companyId);
    }

    return this.http.get(`${this.env.e.url}/db2sms/db2SmsConfigs/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

    ngOnInit(): void {
      this.reload();
    }
}
